import React, { Component } from 'react'

import IconTooltip from './IconTooltip'

export default class EvacuationScore extends Component {
  getEvacuationScoreClass (score) {
    let clazz = ''
    if (score > 66) {
      clazz = 'voldoende'
    } else if (score < 34) {
      clazz = 'onvoldoende'
    } else {
      clazz = 'kritiek'
    }

    return clazz
  }

  getEvacuationScore (score) {
    let totalScore
    totalScore = score

    return totalScore
  }

  render () {
    const { scan } = this.props

    const scoreOriginClass = this.getEvacuationScoreClass(scan.evacuationTimeScoreOriginSpace)
    const scoreAdjacentClass = this.getEvacuationScoreClass(scan.evacuationTimeScoreAdjacentSpace)

    const scoreOriginScore = this.getEvacuationScore(scan.evacuationTimeScoreOriginSpace)
    const scoreAdjacentScore = this.getEvacuationScore(scan.evacuationTimeScoreAdjacentSpace)

    const text = '<p><strong>Ontstaansruimte</strong></p>' +
          '<p>ASET: ' + scan.asetOriginSpace + '</p>' +
          '<p>RSET: ' + scan.rsetOriginSpace + '</p>' +
          '<p>Score: ' + scoreOriginScore + '</p>' +
          '<p><strong>Buiten ontstaansruimte</strong></p>' +
          '<p>ASET: ' + scan.asetAdjacentSpace + '</p>' +
          '<p>RSET: ' + scan.rsetAdjacentSpace + '</p>' +
          '<p>Score: ' + scoreAdjacentScore + '</p>'

    return (
      <div className='block'>
        <h2>Score ontruimingstijd <IconTooltip
          text='<p>Cruciaal voor het bepalen van de brandveiligheid is of personen voldoende tijd hebben om in veiligheid te komen bij brand. Dit hangt af van hoeveel tijd er beschikbaar is om te ontruimen (Available Safe Egress Time, ASET) en hoeveel tijd er benodigd is om iedereen te ontruimen (Required Safe Egress Time, RSET).</p><p>Wanneer de benodigde tijd de beschikbare tijd overschrijdt, is het te verwachten dat er slachtoffers vallen (score: Onvoldoende). Maar ook wanneer deze tijden ongeveer dezelfde duur kennen, is het niet onwaarschijnlijk dat er slachtoffers zijn (score: Kritiek). Slechts wanneer de beschikbare tijd anderhalf keer de lengte van de benodigde tijd bedraagt, wordt dit bestempeld als &lsquo;Voldoende&rsquo;.</p>'
          icon='far fa-info-circle' /><IconTooltip text={text} icon='far fa-info-circle' /></h2>
        <div className='pill-rule'>
          <div className='pill-container'>
            <div className={`pill ${scoreOriginClass === 'onvoldoende' ? 'onvoldoende' : ''}`}>Onvoldoende</div>
            <div className={`pill ${scoreOriginClass === 'kritiek' ? 'kritiek' : ''}`}>Kritiek</div>
            <div className={`pill ${scoreOriginClass === 'voldoende' ? 'voldoende' : ''}`}>Voldoende</div>
            <span className='line-indicator' style={{ left: scoreOriginScore + '%' }} />
          </div>
          <div className='text'>voor personen <strong><u>binnen</u></strong> de ontstaansruimte van de brand.</div>
        </div>
        <div className='pill-rule'>
          <div className='pill-container'>
            <div className={`pill ${scoreAdjacentClass === 'onvoldoende' ? 'onvoldoende' : ''}`}>Onvoldoende</div>
            <div className={`pill ${scoreAdjacentClass === 'kritiek' ? 'kritiek' : ''}`}>Kritiek</div>
            <div className={`pill ${scoreAdjacentClass === 'voldoende' ? 'voldoende' : ''}`}>Voldoende</div>
            <span className='line-indicator' style={{ left: scoreAdjacentScore + '%' }} />
          </div>
          <div className='text'>voor personen <strong><u>buiten</u></strong> de ontstaansruimte van de brand.</div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/EvacuationScore.js